import { render, staticRenderFns } from "./ScreensSingle.vue?vue&type=template&id=6af221d4&"
import script from "./ScreensSingle.vue?vue&type=script&lang=js&"
export * from "./ScreensSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports